import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  taskNotificationCount: 0,
  globalTaskNotificationCount: 0,
};

const taskNotificationSlice = createSlice({
  name: 'taskNotification',
  initialState: initialState,
  reducers: {
    setTaskNotificationCount(state, { payload }) {
      state.taskNotificationCount = payload;
    },
    setGlobalTaskNotificationCount(state, { payload }) {
      state.globalTaskNotificationCount = payload;
    },
  },
});

export const { setTaskNotificationCount, setGlobalTaskNotificationCount } =
  taskNotificationSlice.actions;

export const taskNotificationReducer = taskNotificationSlice.reducer;
